/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Skipped_HintInputs */

const cs_pm_skipped_hint = /** @type {(inputs: Pm_Skipped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento inzerát se neuloží.`)
};

const en_pm_skipped_hint = /** @type {(inputs: Pm_Skipped_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This listing won't be saved.`)
};

/**
* | output |
* | --- |
* | "This listing won't be saved." |
*
* @param {Pm_Skipped_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_skipped_hint = /** @type {((inputs?: Pm_Skipped_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Skipped_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_skipped_hint(inputs)
	return cs_pm_skipped_hint(inputs)
});